if (!customElements.get("expandable-list")) {
  class ComponentExpandableList extends HTMLElement {
    constructor() {
      super();

      this.expanders = [];

      const viewMoreEl = document.createElement("a");
      viewMoreEl.innerHTML = `View More`;
      viewMoreEl.classList.add("expandable-view-more");
      viewMoreEl.href = "#";

      const expandedItems = parseInt(this.dataset.displayItems);
      const elLists = this.querySelectorAll("ul");
      Array.from(elLists).forEach((elList) => {
        elList.parentNode.appendChild(viewMoreEl);
        this.expanders.push(viewMoreEl);

        const elItems = elList.querySelectorAll("li");
        
        if (elItems.length <= expandedItems) viewMoreEl.style.display = "none";

        Array.from(elItems).forEach((elItem, indexElItem) => {
          if (indexElItem >= expandedItems) elItem.style.display = "none";
        });
      });

      this.initExpanders();
    }

    initExpanders() {
      this.expanders.forEach((expander) => {
        expander.addEventListener("click", (event) => {
          event.preventDefault();
          Array.from(this.parentNode.querySelectorAll("ul li")).forEach(
            (elItem) => (elItem.style.display = "list-item")
          );
          expander.style.display = "none";
        });
      });
    }
  }
  customElements.define("expandable-list", ComponentExpandableList);
}
